export default __webpack_public_path__ + "static/media/FemaleStudent.0a9b1b06.svg";